import Http from './axios-config';

/** The superAdmin settings that take effect immediately (GET/PUT /admins/settings). */
class AppSettingsService {

    constructor() {
        this.http = new Http();
    }

    async getSettings() {
        return await this.http.get('/admins/settings');
    }

    /** The same settings, for a page that only mentions them: a failure shows no error toast. */
    async getSettingsQuietly() {
        return await this.http.get('/admins/settings', { silentErrors: true });
    }

    async setPatientListRestriction(enabled) {
        return await this.http.put('/admins/settings/patient-list-restriction', { enabled });
    }

    async setFullPatientAccess(clinicianId, enabled) {
        return await this.http.put(`/admins/settings/clinicians/${clinicianId}/full-patient-access`, { enabled });
    }
}

export default new AppSettingsService();
